// =====================================================
// AMACLI - ARQUIVO CENTRAL DE CONTEÚDO DO SITE
// Para atualizar o site (fotos, documentos, contatos),
// basta editar este arquivo e rodar "yarn build".
// =====================================================

export const ORG = {
  nome: "AMACLI - Associação Itakira",
  razaoSocial: "Associação de Artes Marciais Cultura e Lazer Itakira",
  sigla: "AMACLI",
  cnpj: "26.039.136/0001-07",
  fundacao: "07 de julho de 2016",
  endereco: "Rua da Torre, 609B - Centro, Canaã dos Carajás - PA",
  cep: "CEP 68.537-000",
  whatsapp: "5594991430043",
  whatsappFormatado: "+55 (94) 99143-0043",
  instagram: "https://www.instagram.com/associacao_itakira_judo",
  instagramHandle: "@associacao_itakira_judo",
};

// ---------- DOCUMENTOS DE TRANSPARÊNCIA (TCM-PA) ----------
// Para adicionar um novo documento:
// 1. Copie o PDF para a pasta frontend/public/documentos/
// 2. Adicione um item abaixo com o nome do arquivo.
export const CATEGORIAS_DOCS = ["Todos", "Institucional", "Prestação de Contas", "Certidões"];

export const DOCUMENTOS = [
  {
    titulo: "Estatuto Social",
    categoria: "Institucional",
    ano: "2015",
    descricao: "Estatuto Social consolidado da AMACLI, com objeto social, diretoria e normas de governança.",
    arquivo: "documentos/estatuto-social.pdf",
  },
  {
    titulo: "Cartão CNPJ",
    categoria: "Institucional",
    ano: "2016",
    descricao: "Comprovante de Inscrição e de Situação Cadastral no CNPJ (Receita Federal do Brasil).",
    arquivo: "documentos/cartao-cnpj.pdf",
  },
  // Exemplo de como adicionar a prestação de contas:
  // {
  //   titulo: "Prestação de Contas 2025",
  //   categoria: "Prestação de Contas",
  //   ano: "2025",
  //   descricao: "Demonstrativo de receitas e despesas do exercício de 2025.",
  //   arquivo: "documentos/prestacao-contas-2025.pdf",
  // },
];

// ---------- GALERIA DE FOTOS ----------
// Fotos reais do Instagram @associacao_itakira_judo, hospedadas em
// frontend/public/assets/galeria/. Para adicionar fotos: copie a imagem
// para essa pasta e adicione um item abaixo.
export const CATEGORIAS_FOTOS = ["Todos", "Competições", "Graduações", "Projetos Sociais", "Eventos"];

const G = `${process.env.PUBLIC_URL}/assets/galeria`;

export const GALERIA = [
  {
    src: `${G}/panamericano-kaike-1.jpg`,
    titulo: "Sensei Kaike — bicampeão pan-americano de judô",
    categoria: "Competições",
    data: "Bogotá, Colômbia",
  },
  {
    src: `${G}/panamericano-kaike-2.jpg`,
    titulo: "Medalha de ouro no Pan-Americano",
    categoria: "Competições",
    data: "Bogotá, Colômbia",
  },
  {
    src: `${G}/sulamericano-1.jpg`,
    titulo: "Campeão sul-americano por equipe",
    categoria: "Competições",
    data: "Assunção, Paraguai",
  },
  {
    src: `${G}/sulamericano-2.jpg`,
    titulo: "Vice-campeonato sul-americano de judô",
    categoria: "Competições",
    data: "Assunção, Paraguai",
  },
  {
    src: `${G}/sulamericano-3.jpg`,
    titulo: "Delegação Itakira no Sul-Americano",
    categoria: "Competições",
    data: "Assunção, Paraguai",
  },
  {
    src: `${G}/exame-faixa-1.jpg`,
    titulo: "Conclusão do exame de faixa",
    categoria: "Graduações",
    data: "Canaã dos Carajás - PA",
  },
  {
    src: `${G}/exame-faixa-2.jpg`,
    titulo: "Alunos e senseis na graduação",
    categoria: "Graduações",
    data: "Canaã dos Carajás - PA",
  },
  {
    src: `${G}/projeto-kimonos-1.jpg`,
    titulo: "Entrega de kimonos — Projeto 'A Sala de Aula e o Tatame'",
    categoria: "Projetos Sociais",
    data: "Parceria Construtora Barbosa Mello",
  },
  {
    src: `${G}/projeto-kimonos-2.jpg`,
    titulo: "Alunos do projeto social com os novos kimonos",
    categoria: "Projetos Sociais",
    data: "Parceria Construtora Barbosa Mello",
  },
  {
    src: `${G}/projeto-kimonos-3.jpg`,
    titulo: "Projeto social em ação no tatame",
    categoria: "Projetos Sociais",
    data: "Canaã dos Carajás - PA",
  },
  {
    src: `${G}/projeto-kimonos-4.jpg`,
    titulo: "Turma do Projeto 'A Sala de Aula e o Tatame'",
    categoria: "Projetos Sociais",
    data: "Canaã dos Carajás - PA",
  },
  {
    src: `${G}/seminario-arbitragem-1.jpg`,
    titulo: "Seminário de arbitragem paralímpica",
    categoria: "Eventos",
    data: "Canaã dos Carajás - PA",
  },
  {
    src: `${G}/seminario-arbitragem-2.jpg`,
    titulo: "Seminário com o sensei Laedson Lopes",
    categoria: "Eventos",
    data: "Canaã dos Carajás - PA",
  },
];

export const buildWhatsAppLink = ({ nome, assunto, mensagem }) => {
  const texto = `Olá! Meu nome é ${nome}.\nAssunto: ${assunto}\n\n${mensagem}`;
  return `https://wa.me/${ORG.whatsapp}?text=${encodeURIComponent(texto)}`;
};
